export default function measureListHeight({ container, rows, contentHeight, maxRows, availableHeight = Infinity }) {
  const cappedHeight =
    rows.length <= maxRows
      ? contentHeight
      : rows[maxRows - 1].getBoundingClientRect().bottom - container.getBoundingClientRect().top;
  if (rows.length === 0) {
    return Math.min(cappedHeight, availableHeight);
  }
  const firstRowHeight = rows[0].getBoundingClientRect().bottom - container.getBoundingClientRect().top;
  return Math.min(cappedHeight, Math.max(availableHeight, firstRowHeight));
}
